import type { CustomFontFamily } from "@redotech/redo-content-builder-common/brand-kit";
import { cssFontFamily } from "@redotech/redo-model/brand-kit/font-utils";
import { escapeCssString } from "./escape-css-string";

function fontFormatFromUrl(url: string): string | undefined {
  const path = url.split("?")[0]?.toLowerCase() ?? url.toLowerCase();
  if (path.endsWith(".woff2")) {
    return "woff2";
  }
  if (path.endsWith(".woff")) {
    return "woff";
  }
  if (path.endsWith(".ttf")) {
    return "truetype";
  }
  if (path.endsWith(".otf")) {
    return "opentype";
  }
  return undefined;
}

export function buildCustomFontFaceRules({
  customFontFamilies,
  selectedFontFamilies,
}: {
  customFontFamilies?: CustomFontFamily[] | null;
  selectedFontFamilies: Set<string>;
}): string[] {
  if (!customFontFamilies?.length || selectedFontFamilies.size === 0) {
    return [];
  }

  return customFontFamilies
    .filter((font) => selectedFontFamilies.has(font.fontFamily))
    .flatMap((font) =>
      font.styles.map((style) => {
        const format = fontFormatFromUrl(style.fontFileUrl);
        const formatSuffix = format ? ` format("${format}")` : "";
        return `@font-face { font-family: ${cssFontFamily(font.fontFamily)}; src: url("${escapeCssString(style.fontFileUrl)}")${formatSuffix}; font-weight: ${style.weight || "400"}; font-style: ${style.italic ? "italic" : "normal"}; font-display: swap; }`;
      }),
    );
}
